import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';
import { ssoUserSchema } from '../schemas/sso-user.schema';

/**
 * Create/Update a user. Have the option to assign the created/updated user a list of product roles
 * @param accountId Id of the account
 * @param request.email user's email
 * @param request.firstname user's first name
 * @param request.lastName user's last name
 * @param request.password user password (Optional)
 * @param request.productRoles array of products and their corresponding roles (Optional)
 * @returns created/updated user info (If user was created/updated and roles were assigned)
 */
export function postUsersAccountsProductsV2(
  this: unknown,
  accountId: number,
  request: {
    email: string;
    firstName: string;
    lastName: string;
    password?: string;
    productRoles?: {
      applicationName: null | string;
      roles: { name: string }[];
    }[];
  }
) {
  return fromFetch(
    new Request(
      `${
        authwsEnvironment.resolve(this).usersV2Url
      }/accounts/${encodeURIComponent(accountId)}/products`,
      {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
        body: JSON.stringify(request),
      }
    )
  ).pipe(
    selectData(
      z.object({
        data: ssoUserSchema.nullable().optional(),
        errorList: z.array(
          z.object({
            code: z.string(),
            description: z.string(),
          })
        ),
        status: z.union([z.literal('Successful'), z.literal('Failed')]),
      })
    )
  );
}
